<template>
  <div>
    <page-title icon="fa fa-shopping-cart" main="Pedidos" sub="Pedidos">
      <template v-slot:actions>
        <base-button @click="download" type="neutral" class="ml-3" size="sm">Download</base-button>
      </template>
      
    </page-title>
    <template>
      <base-button @click="goToPurchaseOrders()" type="primary" class="mb-2">Voltar</base-button>
    </template>
    <card
      id="invoice-holder"
    >
      <div slot="header">
        <span>Extrato</span>
      </div>
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <div class="client-info">
            <span class="title">Dados do Cliente</span>
            <p>Razão Social: {{ purchase_order.client.razao_social }}</p>
            <p>Código: {{ purchase_order.client.code }}</p>
            <p>CPF/CNPJ: {{ purchase_order.client.cpf }}</p>
            <p>Fantasia: {{ purchase_order.client.razao_social }}</p>
            <p>Endereço: {{ purchase_order.client.endereco }}</p>
            <p>Telefone: {{ purchase_order.client.primary_phone }}</p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="client-info">
            <span class="title">Dados da Propriedade</span>
            <p>Nome: {{ purchase_order.property && purchase_order.property.descricao }}</p>
            <p>Endereço: {{ purchase_order.property && purchase_order.property.endereco }} - {{ purchase_order.property && purchase_order.property.cep }}</p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="order-info">
            <span class="title">Informações Gerais</span>
            <p>Vendedor: {{ purchase_order.user_id }} {{ purchase_order.user.name }}</p>
            <p>Condição Pgto: {{ purchase_order.payment_type.name}}</p>
            <p>Vencimento: {{ purchase_order.due_date | formatDate}}</p>
          </div>
        </div>
        <div class="col-md-12 col-sm-12">
          <el-table
            class="table-responsive table-striped clickable-rows"
            header-row-class-name="thead-light"
            :data="order_items"
            ref="order_items"
          >
            <el-table-column 
              label="Nome Produto" 
              prop="product.description" 
              min-width="170px"
              sortable
            />
            <el-table-column 
              label="Marca" 
              min-width="220px"
              prop="product.brand" 
              sortable
            />
            <el-table-column 
              label="Quantidade" 
              min-width="140px"
              prop="quantity" 
              sortable
            />
            <el-table-column 
              label="Data Vencimento" 
              min-width="180px"
              sortable
              v-slot="{row}" 
            >
              {{purchase_order.due_date | formatDate}}
            </el-table-column>

            <el-table-column 
              label="Valor total" 
              min-width="160px"
              v-slot="{row}" 
              sortable
            >
              <span>{{row.total_cost.toLocaleString('pt-BR', {style: 'currency', currency: 'brl'})}}</span>
            </el-table-column>
            <el-table-column 
              label="Descontos" 
              min-width="160px"
              v-slot="{row}" 
              sortable
            > 
              <div class="tags-input__wrapper">
                <el-tag 
                  size="mini"
                  effect="dark"
                  :closable="false"
                  class="tagproduto"
                  v-if="discountPerProduct(row.product.preferredproduct_id)"
                >
                {{discountPerProduct(row.product.preferredproduct_id)}}%
                </el-tag>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-md-12" style="margin: 12px 0;text-align: right">
          __________________________________________
        </div>
        <div class="col-12" style="right: 12px;text-align: right" v-if="data_setted">
          Total: R$ {{purchase_order.total_cost.toFixed(2)}}
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import { Table, TableColumn, Tag } from "element-ui";
import PageTitle from "@/layouts/PageTitle";
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
  name: "invoice",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    PageTitle,
    [Tag.name]: Tag ,
  },
  data() {
    return {
      client: {},
      purchase_order: {
        client: {},
        campaign_active_discounts: {}
      },
      order_items: [],
      data_setted: false,
      is_manager: false,
    }
  },
  mounted(){
    this.setPurchaseOrder();
    this.setOrderItems();
    this.dicoverManager();
    
  },
  methods: {
    goToPurchaseOrders() {
      this.$router.push('/purchase_orders');
    },
    setPurchaseOrder() {
      this.$http.secured
        .get(`/api/v1/purchase_orders/${this.$route.params.purchase_order_id}`)
        .then(response => {
          this.purchase_order = response.data;
          this.data_setted    = true
        })
        .catch(error => this.setError(error, "failed to fetch branches"));
    },
    cancel(callback){
      swal.queue([{
        title: 'Tem Certeza?',
        text: "O Vendedor será notificado da sua decisão!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Tenho Certeza!',
        showClass: {
          popup: 'swal2-noanimation',
          backdrop: 'swal2-noanimation'
        },
        preConfirm: () => {
          swal.insertQueueStep({
            input: 'textarea',
            inputPlaceholder: 'Motivar Canvelamento...',
            inputAttributes: {
              'aria-label': 'Motivar Cancelamento'
            },
            showClass: {
              popup: 'swal2-noanimation',
              backdrop: 'swal2-noanimation'
            },
            inputValidator: (value) => {
              if (!value) {
                return 'A Motivação é obrigatória!'
              }
            },
            showCancelButton: true
          })
        }
      }]).then((value) => {
        if(!value['dismiss']){
          let valueArray = value['value'];
          callback('canceled', {disapproval_justification: valueArray[(valueArray.length - 1)]})
        }
      });
    },
    confirmDecision(status, callback){
      swal.fire({
        title: 'Tem Certeza?',
        text: "O Vendedor será notificado da sua decisão!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Tenho Certeza!'
      }).then((result) => {
        if (result.value) {
          callback(status)
        }
      })
    },
    updateOrderStatus(status, options = {}){
      let params = {purchase_order: {
          status: status
        }}
      params['purchase_order'] = Object.assign(params['purchase_order'], options)  

      this.$http.secured
        .put(`/api/v1/purchase_orders/${this.$route.params.purchase_order_id}`, params)        
        .then(response => {
          this.$toasted.global.defaultSuccess();
        })
        .catch(error => {
          this.setError(error, "Cannot save Sector")
        });
    },
    dicoverManager (){
      return this.is_manager = (localStorage.currentUser.is_manager || localStorage.currentUser.is_admin || localStorage.currentUser.has_coordinateds)
    },
    discountPerProduct(id){
      return this.purchase_order.campaign_active_discounts[id]
    },
    setOrderItems() {
      //  Adicionando valores default a query e ao número da página se não definidos
      this.$http.secured
        .get(`/api/v1/purchase_orders/${this.$route.params.purchase_order_id}/order_items`, {
          params: {
            purchase_order_id: this.$route.params.purchase_order_id,
          }
        })
        .then(response => {
          this.order_items  = response.data.order_items;

        })
        .catch(error => this.setError(error, "Something went wrong"));
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    async download() {
      try {
        const response = await this.$http.secured.get(`/api/v1/purchase_orders/${this.$route.params.purchase_order_id}/invoice`, {
          responseType: 'arraybuffer',
        });

        // Starting file donwload
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute(
          "download",
          `Recibo_${this.$route.params.purchase_order_id}.pdf`
        );
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.error(error);
      }
    }
  }
}
</script>
<style scoped lang="scss">
  .title{
    font-weight: 500;
  }
  .order-info, .client-info{
    p{
      padding: 0;
      margin: 0;
    }
    margin-bottom: 32px;
  }
</style>
